
import { useAuthContext } from '@dbg-ui/auth';
import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AuthorizationNotice from './components/AuthorizationNotice';
import CookieScript from './components/CookieScript';
import CurrentUserErrorNotice from './components/CurrentUserErrorNotice';
import Footer from './components/Footer';
import Header from './components/Header';
import { Home, NotFound } from './pages';
import UserConnections from "./pages/UserConnections";

function Router() {
    const authContext = useAuthContext();
    const [authInitialized, setAuthInitialized] = useState(false);

    useEffect(() => {
        let active = true;

        Promise.resolve(authContext.initAuth())
            .catch(() => undefined)
            .finally(() => {
                if (active) {
                    setAuthInitialized(true);
                }
            });

        return () => {
            active = false;
        };
        // Authentication must initialize once before protected routes can decide access.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const requireAuth = (element) => {
        if (!authInitialized) {
            return null;
        }
        return authContext.isAuthenticated ? element : <Navigate to='/' replace/>;
    };

    return (
        <BrowserRouter>
            <Header/>
            <AuthorizationNotice/>
            <CurrentUserErrorNotice/>
            <Routes>
                <Route path='/' element={<Home/>}/>
                <Route path='/user-connections' element={requireAuth(<UserConnections/>)}/>
                <Route path='*' element={
                        <NotFound/>
                }/>
            </Routes>
            <Footer/>
            <CookieScript/>
        </BrowserRouter>
    );
}

export default Router;
